import { useState } from 'react'

const FAQS = [
    {
        question: 'How are you different from other agent mail vendors?',
        answer: "Most agent mail vendors are template-and-print shops - pick a postcard, upload a list, hit send. We know how data, strategy, direct mail, and tracking work together to create campaigns that actually produce listings. That includes building the right list for your farm, designing creative that matches your brand instead of looking like every other agent's postcard, and reading the response data to make the next drop better than the last. We're also good at diagnosing existing campaigns - if you're already mailing with another vendor and it's not working, we'll tell you why and what to change, whether or not you move to us.",
    },
    {
        question:
            "How is this different from EDDM or my brokerage's marketing tools?",
        answer: 'EDDM mails every address on a carrier route - useful for basic awareness, but it ignores who actually lives in the home and how likely they are to move. Brokerage marketing tools usually give you templates, but no real strategy, list-building, or response tracking. We add the layer most agents are missing: targeted lists, custom creative, multi-touch cadence, and the data to know which drops are actually working.',
    },
    {
        question:
            'How fast can you turn around just-listed and just-sold mailers?',
        answer: 'We offer 2-business-day production for most formats once creative and lists are approved. For just-listed and just-sold campaigns, the creative and list templates are pre-built - mail can ship within a business day of the listing going live or closing.',
    },
    {
        question: "What's the minimum spend to get started?",
        answer: "This is built for top-producing agents and teams running an active farm - not one-off mailers. There's no fixed minimum, but the value shows up in a repeatable program: recurring farm drops, just-listed and just-sold triggers running in the background, and tracking that compounds over months. If you only need a single batch of postcards at the lowest possible per-piece price, we may not be the right fit.",
    },
    {
        question:
            'Can you handle creative, or do I need to provide the design?',
        answer: "We handle it. Most of our agent clients want mail that looks like their brand, not a stock template - so we design around your logo, colors, and positioning. You can also bring your own creative if you have a designer or in-house brand team. Either way, we'll flag anything that we think will hurt response.",
    },
]

function PlusIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    )
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null)

    return (
        <section className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 lg:py-16">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        Frequently asked
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3F454F] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Questions agents ask first.
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    {FAQS.map((faq, i) => (
                        <div
                            key={i}
                            className="flex flex-col rounded-2xl border border-secondary/30 bg-white">
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenIndex(openIndex === i ? null : i)
                                }
                                className="flex w-full cursor-pointer flex-row items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left transition-colors hover:bg-secondary/[0.03]">
                                <span
                                    className="text-lg font-semibold text-[#3F454F]"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.question}
                                </span>
                                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10">
                                    <PlusIcon
                                        className={`h-4 w-4 text-secondary transition-transform duration-200 ${
                                            openIndex === i ? 'rotate-45' : ''
                                        }`}
                                    />
                                </div>
                            </button>
                            <div
                                className="overflow-hidden transition-all duration-300"
                                style={{
                                    maxHeight: openIndex === i ? '600px' : '0',
                                    opacity: openIndex === i ? 1 : 0,
                                }}>
                                <div
                                    className="px-6 pb-6 text-lg text-[#3F454F]/70"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
